import React from 'react';
import cn from 'clsx';

import Button, { ButtonGroup } from '../../library/button/button';
import Typography from '../../library/typography/typography';

import { PRODUCT_TYPES } from '../../shared/constants/products';

import styles from './modify-entry-confirmation.scss';

const ACTIONS = { CHANGE: 'CHANGE', REMOVE: 'REMOVE' };

export interface ModifyEntryConfirmationProps {
  action?: 'CHANGE' | 'REMOVE';
  className?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  productType?: string;
}

function ModifyEntryConfirmation(props: ModifyEntryConfirmationProps) {
  const {
    action = '',
    className = '',
    onCancel,
    onConfirm,
    productType
  } = props;

  if (action && !ACTIONS?.[action]) {
    return null;
  }

  const productTypeText =
    productType === PRODUCT_TYPES.TIRES ? 'tires' : 'wheels';

  const actionToTextMap = {
    [ACTIONS.CHANGE]: {
      description: `Choosing to shop different ${productTypeText} will allow you to swap out your current selections.`,
      primaryButtonText: `Keep ${productTypeText}`,
      prompt: `Choose different ${productTypeText}?`,
      secondaryButtonText: `Choose ${productTypeText}`
    },
    [ACTIONS.REMOVE]: {
      description: `By removing products from the package, any related discounts will be removed.`,
      primaryButtonText: `Keep ${productTypeText}`,
      prompt: `Remove ${productTypeText}?`,
      secondaryButtonText: `Remove ${productTypeText}`
    }
  };

  return (
    <div
      className={cn(
        styles['container'],
        `modify-entry-confirmation ${className}`
      )}
      data-testid="modify-entry-confirmation"
    >
      <div
        className={cn(styles['content'], 'modify-entry-confirmation__content')}
      >
        <Typography
          className={styles['prompt-title']}
          variant="H6"
          weight="black"
        >
          {actionToTextMap[action]?.prompt}
        </Typography>
        <Typography className={styles['prompt']} variant="H6">
          {actionToTextMap[action]?.description}
        </Typography>
        <ButtonGroup>
          <Button isSecondary onClick={onConfirm}>
            {actionToTextMap[action]?.secondaryButtonText}
          </Button>
          <Button isPrimary onClick={onCancel}>
            {actionToTextMap[action]?.primaryButtonText}
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
}

export { ACTIONS };

export default ModifyEntryConfirmation;
